module.exports = __webpack_public_path__ + "img/2.f0e5f4c8.jpg";